
import { useState } from "react";
import { useNavigate } from "react-router-dom"
import { Button } from "@/components/ui/button"
import { SubscriptionPlansTable } from "@/components/admin/subscriptions/SubscriptionPlansTable"
import { UserSubscriptionsTable } from "@/components/admin/subscriptions/UserSubscriptionsTable"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs"
import { useSubscriptions } from "@/hooks/useSubscriptions"
import { toast } from "sonner"
import { UserSubscription } from "@/hooks/subscriptions/types"

export function SubscriptionsManager() {
  const [activeTab, setActiveTab] = useState("plans")
  const navigate = useNavigate()
  
  const {
    useSubscriptionPlansQuery,
    useAllUserSubscriptionsQuery,
    useDeleteSubscriptionPlanMutation,
    useAssignUserSubscriptionMutation
  } = useSubscriptions()
  
  const { data: plans = [], isLoading: plansLoading, refetch: refetchPlans } = useSubscriptionPlansQuery()
  const { data: subscriptions = [], isLoading: subscriptionsLoading } = useAllUserSubscriptionsQuery()
  
  const deletePlan = useDeleteSubscriptionPlanMutation()
  const assignSubscription = useAssignUserSubscriptionMutation()
  
  const handleCreatePlan = () => {
    navigate('/admin/subscription-plans/new')
  }
  
  const handleDeletePlan = async (planId: string) => {
    try {
      await deletePlan.mutateAsync(planId)
      toast.success("Subscription plan deleted successfully")
      refetchPlans()
    } catch (error) {
      console.error("Failed to delete plan:", error)
      toast.error("Failed to delete subscription plan. Please try again.")
    }
  }
  
  const handleAssignSubscription = async (subscriptionData: any) => {
    try {
      await assignSubscription.mutateAsync(subscriptionData)
      toast.success("Subscription assigned successfully")
    } catch (error) {
      console.error("Failed to assign subscription:", error)
      toast.error("Failed to assign subscription. Please try again.")
    }
  }
  
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-2xl font-bold">Subscription Management</h2>
        {/* Removed the top "New Plan" button */}
      </div>
      
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList>
          <TabsTrigger value="plans">Plans</TabsTrigger>
          <TabsTrigger value="users">User Subscriptions</TabsTrigger>
        </TabsList>
        
        <TabsContent value="plans" className="mt-4">
          <SubscriptionPlansTable 
            plans={plans}
            onDeletePlan={handleDeletePlan}
            isLoading={plansLoading}
          />
        </TabsContent>
        
        <TabsContent value="users" className="mt-4">
          <UserSubscriptionsTable 
            subscriptions={subscriptions as unknown as UserSubscription[]}
            plans={plans}
            onAssignSubscription={handleAssignSubscription}
            isLoading={subscriptionsLoading}
          />
        </TabsContent>
      </Tabs>
    </div>
  )
}
